// Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Components
import { ChaptersComponent } from './chapters.component';

/**
 * Routes
 */
const routes: Routes = [
  {path: '', component: ChaptersComponent}
];

/**
 * Chapters Routing Module
 */
@NgModule({
  imports: [
    // Angular
    RouterModule.forChild(routes),
  ],
  exports: [
    // Angular
    RouterModule,
  ]
})
export class ChaptersRoutingModule {
}
